import {
    createSelector,
} from '@reduxjs/toolkit';

import {
    selectUserSelectionIds,
    selectCountUserSelectionsWithoutCombinations,
} from './userSelectionsSelectors';

import {
    selectBetReceiptExists,
    selectBetReceiptIds,
    selectCountReceiptSelections,
} from './betReceiptSelectors';

import {
    selectRecommendationGlobalEnabled,
    selectRecommendationBetPlacementEnabled,
    selectRecommendationBetReceiptEnabled,
} from '~SpectateStore/selectors/clientStateSelectors';

export const selectRecommendations = state => state.betslip.recommendations;

export const selectShouldQueryRecommendations = createSelector(
    [
        selectCountUserSelectionsWithoutCombinations,
        selectCountReceiptSelections,
        selectRecommendationGlobalEnabled,
        selectRecommendationBetPlacementEnabled,
        selectRecommendationBetReceiptEnabled,
    ],
    (
        betslipCount,
        receiptCount,
        isRecommendationGlobalEnabled,
        isRecommendationBetPlacementEnabled,
        isRecommendationBetReceiptEnabled
    ) => {
        if (!isRecommendationGlobalEnabled) {
            return false;
        }

        const shouldGetBetslipRecommendations = isRecommendationBetPlacementEnabled && betslipCount > 0 && receiptCount < 1;
        const shouldGetBetReceiptRecommendations = isRecommendationBetReceiptEnabled && receiptCount > 0;

        return shouldGetBetslipRecommendations || shouldGetBetReceiptRecommendations;
    }
);

export const selectRecommendationsSelectionsIds = createSelector(
    [
        selectBetReceiptExists,
        selectUserSelectionIds,
        selectBetReceiptIds,
    ],
    (isBetReceipt, betslipSelections, betReceiptSelections) => {
        const data = isBetReceipt ? betReceiptSelections : betslipSelections;

        /**
         * Compound selection ids are based on ids of underlying selections:
         * Forecast and tricast selections: selectionIds.join('_')
         * Combination selections: <2-letter-combo-slug> + '_' + selectionIds.join('_')
         * In order to get recommendations for them we must split the "single" selection id
         * into mupltiple ones so we pass to BE "1,2,3" instead of "1_2_3"
         */
        const output = data.reduce(
            (selectionIds, id) => {
                if (!isNaN(id)) {
                    selectionIds.push(id);

                    return selectionIds;
                }

                const ids = id.split('_').filter(id => !isNaN(id));

                // remove duplicates
                return Array.from(new Set([...selectionIds, ...ids]));
            },
            [],
        );

        return output;
    }
);
